(function () {
    'use strict';

    var togglers = document.querySelectorAll('.toggler');

    togglers.forEach(function (toggler) {
        toggler.addEventListener('click', function (event) {
            var clickedToggler = event.target.closest('.toggler-item');
            if (!clickedToggler) return;

            var parentSet = clickedToggler.closest('[set]');
            var setId = parentSet ? parentSet.getAttribute('set') : null;
            if (!setId) return;

            var buttons = Array.prototype.slice.call(
                clickedToggler.parentElement.querySelectorAll('.toggler-item')
            );
            var selectedIndex = buttons.indexOf(clickedToggler);

            // 👉 Find all togglers with the same setId
            var allTogglersWithSameSet = document.querySelectorAll('[set="' + setId + '"] .toggler');

            allTogglersWithSameSet.forEach(function (togglerGroup) {
                var togglerButtons = togglerGroup.querySelectorAll('.toggler-item');

                // 👉 If the button in this toggler is not the clicked one, trigger a click on it
                togglerButtons.forEach(function (btn, idx) {
                    if (idx === selectedIndex && btn !== clickedToggler) {
                        btn.click(); // simulates click on the others
                    }
                });
            });

            // 👉 Now reset the classes again (just in case – sometimes Vue does it itself)
            allTogglersWithSameSet.forEach(function (togglerGroup) {
                var togglerButtons = togglerGroup.querySelectorAll('.toggler-item');

                togglerButtons.forEach(function (btn, idx) {
                    if (idx === selectedIndex) {
                        btn.classList.add('selected');
                    } else {
                        btn.classList.remove('selected');
                    }
                });
            });
        });
    });
})();
